<template>
  <section id="home" v-navShadow v-navItem class="w-full h-screen">
    <div
      class="
        w-full
        h-full
        bg-black bg-opacity-50
        flex flex-col
        justify-center
        items-center
      "
    >
      <h4 class="text-white text-3xl md:text-6xl font-medium text-center uppercase">
        Empower Girls,
        <br />
        Transform Futures
      </h4>
      <p class="mt-5 mx-3 md:mx-0 text-white text-center text-lg">
        Breaking down barriers to education and rights, creating communities
        <br/>where every girl can choose her own path and reach her full potential.
      </p>

      <a href="#about" class="mt-5 bg-yellow-300 hover:bg-yellow-400 transition-colors rounded-sm shadow-xl px-3 py-2 font-medium text-gray-800">Learn About Us</a>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
section {
  background-size: cover;
  background-image: url(/images/mother.jpg);
}
</style>